// extracted by mini-css-extract-plugin
module.exports = {"container":"CornerContainer-module--container--2F6YI","content":"CornerContainer-module--content--3bZxU"};